"use client";

import { Modal, ModalButtons } from "components/ui/v2";
import useTranslation from "next-translate/useTranslation";
import {
  PreviewCertificateModalContentV2,
  type PreviewCertificateModalContentV2Props,
} from "./PreviewCertificateModalContentV2";

export interface PreviewCertificateModalV2Props {
  open: boolean;
  onClose: () => void;
  certificate: PreviewCertificateModalContentV2Props | null;
}

/**
 * Shell Modal v2 §5.5 — preview de certificado con ModalButtons en footer.
 */
export function PreviewCertificateModalV2({
  open,
  onClose,
  certificate,
}: PreviewCertificateModalV2Props) {
  const { t } = useTranslation("common");

  return (
    <Modal
      open={open && Boolean(certificate)}
      onClose={onClose}
      title={t("Vista previa")}
      eyebrow={t("Certificados")}
      size="md"
      panelClassName="max-h-[min(88vh,680px)]"
      headerClassName="px-4 py-2.5 sm:px-5 sm:py-3"
      bodyClassName="px-4 py-3 sm:px-5 sm:py-3.5"
      footer={
        <ModalButtons
          compact
          cancelLabel={t("Cerrar")}
          onCancel={onClose}
          submitLabel={t("Listo")}
          onSubmit={onClose}
        />
      }
    >
      {certificate ? (
        <PreviewCertificateModalContentV2 {...certificate} />
      ) : null}
    </Modal>
  );
}
